import type { AppRouteModule } from '/@/router/types';

import { LAYOUT2 } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';

const brand: AppRouteModule = {
  path: '/brand',
  name: 'Brand',
  component: LAYOUT2,
  redirect: PageEnum.BRAND_WALL,
  meta: {
    orderNo: 1,
    icon: 'menus-home|svg',
    title: t('routes.brand.brand'),
    hideChildrenInMenu: true,
    hideBreadcrumb: false,
    hideHeader: false,
  },
  children: [
    {
      path: 'wall/:listType?',
      name: 'BrandWall',
      component: () => import('/@/views/brand/allDro/index.vue'),
      meta: {
        title: t('routes.brand.brand'),
        hideBreadcrumb: true,
      },
    },
  ],
};

export default brand;
